/**
 * Queue Domain - Urdu Translations
 */

import type { QueueTranslations } from './en'

export const ur: QueueTranslations = {
  queue: {
    plantStatus: {
      title: 'پلانٹ پر ٹرک',
      outside: 'پلانٹ سے باہر',
      inside: 'پلانٹ کے اندر',
      none: 'کوئی ٹرک نہیں',
      empty: 'اس وقت قطار میں کوئی ٹرک نہیں ہے۔',
      updated: 'اپ ڈیٹ {{time}}',
    },
    waitTimes: {
      title: 'موجودہ انتظار کا وقت',
      hint: 'اگر آپ ابھی قطار میں شامل ہوں تو متوقع انتظار',
      none: 'کوئی انتظار نہیں',
      minutes: '~{{minutes}} منٹ',
      hours: '~{{hours}} گھنٹے',
      hoursMinutes: '~{{hours}} گھنٹے {{minutes}} منٹ',
      unknown: 'دستیاب نہیں',
    },
    // Moving a truck in the queue
    reorderTitle: '{{truck}} کو قطار میں منتقل کریں',
    reorderDescription: 'اس ٹرک کی قطار میں جگہ بدلتا ہے۔ آمد کا وقت تبدیل نہیں ہوتا۔',
    reorderMoveTo: 'منتقل کریں',
    reorderFront: 'قطار کے شروع میں',
    reorderBack: 'قطار کے آخر میں',
    reorderAfter: 'مخصوص ٹرک کے بعد',
    reorderAfterWhich: 'اس کے بعد رکھیں',
    reorderPickTruck: 'ٹرک منتخب کریں',
    reorderReason: 'وجہ',
    reorderReasonPlaceholder: 'یہ ٹرک آگے کیوں جا رہا ہے؟',
    reorderReasonHint: 'کم از کم 3 حروف۔ کوئی مہینوں بعد یہ پڑھ سکتا ہے۔',
    reorderRecordedNotice: 'آپ کا نام، وجہ، اور جن مقامات کے درمیان منتقلی ہوئی، سب محفوظ ہوتے ہیں۔',
    reorderConfirm: 'ٹرک منتقل کریں',
    reorderMoving: 'منتقل ہو رہا ہے…',
    reorderDone: 'ٹرک منتقل ہو گیا۔',
    reorderError: {
      entry_already_called: 'اس ٹرک کو پہلے ہی بلایا جا چکا ہے، اس لیے منتقل نہیں ہو سکتا۔',
      reason_required: 'براہ کرم کم از کم 3 حروف کی وجہ لکھیں۔',
      entry_not_in_queue: 'یہ ٹرک اب اس قطار میں نہیں۔',
      target_not_in_queue: 'آپ کا منتخب کردہ ٹرک اب اس قطار میں نہیں۔',
      target_is_the_entry: 'ٹرک کو خود اپنے بعد نہیں رکھا جا سکتا۔',
      no_room_between: 'ان دو ٹرکوں کے درمیان جگہ نہیں۔ کوئی اور جگہ منتخب کریں۔',
      already_there: 'ٹرک پہلے ہی اسی جگہ ہے۔',
      entry_not_found: 'ٹرک نہیں ملا۔',
      unknown: 'ٹرک منتقل نہیں ہو سکا۔',
    },

    // Queue simulation (read-only sandbox over the live yard)
    simBaseline: 'موجودہ',
    simOnItsWay: 'راستے میں',
    simIdle: 'فارغ',
    simStatWaiting: 'منتظر',
    simStatDone: 'لوڈ ہوئیں',
    simStatWorst: 'طویل ترین انتظار',
    simModeLive: 'یارڈ ابھی',
    simModeReplay: 'گزشتہ دن دہرائیں',
    simModeBlank: 'دن بنائیں',
    simModeLiveHint: 'اس وقت قطار میں موجود اصل ٹرکوں سے شروع کریں۔',
    simModeReplayHint: 'اصل ٹرک، اصل آمد اور لوڈنگ اوقات، ایک ایسی شفٹ سے جو واقعی ہوئی۔',
    simModeBlankHint: 'اصل بے اور ترتیبات، ٹرک کوئی نہیں۔ آرڈر آپ چنتے ہیں۔',
    simPickADay: 'دن منتخب کریں',
    simDayTrucks: '{{trucks}} ٹرک',
    simNoDays: 'دہرانے کے لیے کافی ٹریفک والا کوئی گزشتہ دن نہیں۔',
    simPlay: 'چلائیں',
    simPause: 'روکیں',
    simStep: 'اگلا مرحلہ',
    simAddTrucks: 'ٹرک بھیجیں',
    simAddN: '{{count}} بھیجیں',
    simStart: 'شروع',
    simStarting: 'یارڈ لوڈ ہو رہا ہے…',
    simHowItEnded: 'دن کیسے ختم ہوا',
    simDayComplete: 'تمام ٹرک لوڈ ہو چکے ہیں۔',
    simTheTrade: 'دونوں سطریں ساتھ پڑھیں۔ پولنگ کا فائدہ بدترین صورت میں ہے، اور قیمت درمیان میں۔',
    simTitle: 'قطار کا سمیولیٹر',
    simSubtitle: 'یارڈ کی موجودہ حالت پر تبدیلی آزمائیں۔ یہاں کچھ محفوظ نہیں ہوتا۔',
    simSubtitleFactory: '{{factory}} — یارڈ کی موجودہ حالت۔ یہاں کچھ محفوظ نہیں ہوتا۔',
    simReadOnlyNotice: 'یہ ایک آزمائشی ماحول ہے۔ یہ اصل یارڈ پڑھتا ہے اور بتاتا ہے کیا ہوگا — کوئی بے بند نہیں ہوتا، کسی ڈرائیور کو نہیں بلایا جاتا، اور کوئی قطار نہیں بدلتی۔',
    simBays: 'بے',
    simNoBays: 'اس فیکٹری کے لیے کوئی فعال بے نہیں۔',
    simProductLines: 'مصنوعات کی قطاریں',
    simNoOneWaiting: 'کوئی انتظار میں نہیں۔',
    simWaitingAnyBay: '{{count}} انتظار میں · کوئی بھی بے جو لوڈ کر سکے',
    simAlsoTakes: 'نیز',
    simOpen: 'کھلا',
    simClosed: 'بند',
    simNotLoading: 'لوڈ نہیں ہو رہا',
    simEmptySlot: 'خالی',
    simCalledExpires: 'بلایا گیا · {{minutes}} منٹ باقی',
    simBoundWaiting: 'منسلک اور منتظر ({{count}})',
    simSendAnOrder: 'آرڈر بھیجیں',
    simSearchOrders: 'آرڈر نمبر سے تلاش کریں',
    simNoOrders: 'بھیجنے کے لیے کوئی آرڈر دستیاب نہیں۔',
    simNoCustomer: 'کوئی گاہک نہیں',
    simTypicalLoad: 'عام طور پر {{minutes}} منٹ',
    simSendIn: 'بھیجیں',
    simPlus15: '+15 منٹ',
    simPlusHour: '+1 گھنٹہ',
    simUndo: 'واپس',
    simResetToLive: 'موجودہ حالت پر واپس',
    simSoFar: 'اب تک — {{name}}',
    simChangesMade: 'آپ نے کیا بدلا ({{count}})',
    simWhatHappened: 'کیا ہوا',
    simNothingYet: 'ابھی کچھ نہیں۔ وقت آگے بڑھائیں یا آرڈر بھیجیں۔',
    simWhatThisAssumes: 'یہ کیا فرض کرتا ہے',
    simWhatChanges: 'کیا بدلتا ہے',
    simVs: 'بمقابلہ {{baseline}}',
    simNoMaterialDifference: 'یہاں کوئی قابلِ ذکر فرق نہیں۔ اس پر فیصلہ نہ کریں۔',
    simCompareTodayPooled: 'موجودہ بمقابلہ مشترکہ',
    simCompareTodaySmart: 'موجودہ بمقابلہ سمارٹ بے',
    simCompareAll: 'تینوں',
    simCompareTodayOnly: 'صرف موجودہ',
    simMetricServed: 'لوڈ ہو کر چلی گئیں',
    simMetricWaiting: 'اب بھی منتظر',
    simMetricNoShow: 'بلایا گیا، نہیں آئیں',
    simMetricMessages: 'بھیجے گئے پیغامات',
    simMetricMedianWait: 'اوسط انتظار',
    simMetricP90Wait: '10 میں سے 9 کا انتظار اس سے کم',
    simMetricWorstWait: 'سب سے طویل انتظار',
    simMetricIdleBay: 'بے کے فارغ منٹ جبکہ ٹرک منتظر تھے',
    simMetricOvertakes: 'ایک ہی مصنوعات میں آگے نکلنا',
    simMetricPreExisting: 'شروع کرتے وقت پہلے سے لوڈ ہو رہی تھیں',
    simWaitExplainer: 'انتظار کا وقت ان ٹرکوں کو بھی پورا وقت منتظر شمار کرتا ہے جنہیں کبھی بلایا ہی نہیں گیا — ورنہ لوگوں کو پھنسانے والی قطار اچھی لگے گی۔',
    // Section Titles
    title: 'قطار کا انتظام',
    loadingLocations: 'لوڈنگ مقامات',
    loadingLocationRules: 'لوڈنگ مقام کے قواعد',
    loadingLocationRule: 'لوڈنگ مقام کا قاعدہ',
    queueEntries: 'قطار کے اندراجات',
    dashboard: 'قطار ڈیش بورڈ',

    // Queue switch (packhouse role)
    queueOpen: 'قطار کھلی ہے',
    queueClosed: 'قطار بند ہے',
    bulk: 'بلک',
    bags: 'بیگز',

    // Actions
    addLocation: 'لوڈنگ مقام شامل کریں',
    editLocation: 'لوڈنگ مقام ترمیم کریں',
    deleteLocation: 'لوڈنگ مقام حذف کریں',
    addRule: 'قاعدہ شامل کریں',
    editRule: 'قاعدہ ترمیم کریں',
    deleteRule: 'قاعدہ حذف کریں',
    viewQueue: 'قطار دیکھیں',
    refreshQueue: 'قطار تازہ کریں',
    joinQueue: 'قطار میں شامل ہوں',
    cancelEntry: 'اندراج منسوخ کریں',
    validateEntry: 'اندراج تصدیق کریں',
    recordExit: 'خروج درج کریں',

    // Location Form
    locationForm: {
      title: 'لوڈنگ مقام کی تفصیلات',
      subtitle: 'قطار کے انتظام کے لیے نئی لوڈنگ پوائنٹ ترتیب دیں',
      sectionIdentity: 'شناخت',
      sectionAssignment: 'تفویض',
      sectionCapacity: 'گنجائش اور ڈسپلے',
      label: 'مقام کا نام',
      labelPlaceholder: 'مثلاً بے 1، سائلو 3',
      locationKind: 'مقام کی قسم',
      selectLocationKind: 'قسم منتخب کریں',
      locationNumber: 'نمبر',
      locationNumberPlaceholder: '1',
      deviceId: 'ڈیوائس ID',
      deviceIdPlaceholder: 'device-bay-01',
      deviceIdHint: 'کیوسک / ڈسپلے ڈیوائس کا منفرد شناخت کار',
      factory: 'فیکٹری',
      selectFactory: 'فیکٹری منتخب کریں',
      noFactories: 'کوئی فیکٹری دستیاب نہیں',
      variant: 'مصنوعہ / ویریئنٹ',
      selectVariant: 'مصنوعہ منتخب کریں',
      noVariants: 'کوئی مصنوعہ دستیاب نہیں',
      allowedVariants: 'اضافی مصنوعات',
      allowedVariantsHelp: 'وہ اضافی مصنوعات منتخب کریں جو اس مقام پر قابل قبول ہیں',
      primaryVariant: 'بنیادی مصنوعہ',
      noPrimary: 'کوئی ترجیح نہیں',
      maxVehicles: 'زیادہ سے زیادہ گاڑیاں',
      maxVehiclesPlaceholder: '2',
      maxVehiclesHelp: 'بیک وقت اندر آنے والی گاڑیوں کی تعداد',
      windowNumber: 'ونڈو نمبر',
      windowNumberPlaceholder: '0',
      monitorIndex: 'مانیٹر انڈیکس',
      monitorIndexPlaceholder: '0',
      isActive: 'فعال',
      isActiveHelp: 'نئے قطار اندراجات قبول کریں',
    },

    // Rule Form
    ruleForm: {
      section: 'قاعدہ کی تشکیل',
      loadingLocation: 'لوڈنگ مقام',
      selectLoadingLocation: 'لوڈنگ مقام منتخب کریں',
      cities: 'شہر',
      customers: 'گاہک',
      selectCities: 'شہر منتخب کریں',
      selectCustomers: 'گاہک منتخب کریں',
      allCustomers: 'تمام گاہک',
      anyCity: 'کوئی بھی شہر',
      priority: 'ترجیح',
      description: 'وضاحت',
      descriptionPlaceholder: 'اختیاری وضاحت',
      isActive: 'فعال',
      isActiveHelp: 'آرڈر کو مقام تفویض کرتے وقت یہ قاعدہ لاگو کریں',
    },

    // Rule Fields
    ruleLoadingLocation: 'لوڈنگ مقام',
    ruleCities: 'شہر',
    rulePriority: 'ترجیح',
    ruleDescription: 'وضاحت',
    ruleFilterLocation: 'لوڈنگ مقام',
    ruleFilterCity: 'شہر',

    // Location Kind
    locationKind: {
      bay: 'بے',
      silo: 'سائلو',
    },

    // Queue Status
    status: {
      waiting: 'انتظار میں',
      ready: 'تیار',
      called: 'بلایا گیا',
      entered: 'داخل ہوا',
      loading: 'لوڈنگ جاری',
      completed: 'مکمل',
      cancelled: 'منسوخ',
      expired: 'میعاد ختم',
      noShow: 'غیر حاضر',
      loaded: 'لوڈ ہو گیا',
    },

    // Event Types
    eventType: {
      queue_joined: 'قطار میں شامل ہوا',
      status_changed: 'حیثیت تبدیل',
      notification_sent: 'اطلاع بھیجی',
      entry_validated: 'داخلہ تصدیق شدہ',
      entered_factory: 'فیکٹری میں داخل',
      entered_loading: 'لوڈنگ پوائنٹ پر',
      exited_factory: 'فیکٹری سے باہر',
      slot_released: 'جگہ خالی',
      cancelled: 'منسوخ',
    },

    // Statistics
    stats: {
      totalLocations: 'کل مقامات',
      activeLocations: 'فعال مقامات',
      totalCapacity: 'کل گنجائش',
      currentOccupancy: 'موجودہ قبضہ',
      totalInQueue: 'قطار میں',
      waitingCount: 'انتظار میں',
      readyCount: 'داخلے کے لیے تیار',
      insideCount: 'فیکٹری کے اندر',
      availableSlots: 'دستیاب جگہیں',
      queueLength: 'قطار کی لمبائی',
      avgWaitTime: 'اوسط انتظار کا وقت',
    },

    // Entry Details
    entry: {
      ticketNumber: 'ٹکٹ نمبر',
      queueNumber: 'قطار نمبر',
      orderNumber: 'آرڈر نمبر',
      position: 'قطار میں پوزیشن',
      driver: 'ڈرائیور',
      phone: 'فون',
      vehicle: 'گاڑی',
      order: 'آرڈر',
      product: 'مصنوعہ',
      location: 'لوڈنگ مقام',
      requestedAt: 'درخواست کا وقت',
      notifiedAt: 'اطلاع کا وقت',
      readySince: 'تیار ہونے کا وقت',
      enteredAt: 'داخلے کا وقت',
      exitedAt: 'خروج کا وقت',
      waitTime: 'انتظار کا وقت',
      totalTime: 'کل وقت',
    },

    // Messages
    messages: {
      locationCreated: 'لوڈنگ مقام کامیابی سے بنایا گیا',
      locationUpdated: 'لوڈنگ مقام کامیابی سے اپ ڈیٹ ہوا',
      locationDeleted: 'لوڈنگ مقام کامیابی سے حذف ہوا',
      ruleCreated: 'قاعدہ کامیابی سے بنایا گیا',
      ruleUpdated: 'قاعدہ کامیابی سے اپ ڈیٹ ہوا',
      ruleDeleted: 'قاعدہ کامیابی سے حذف ہوا',
      joinedQueue: 'قطار میں کامیابی سے شامل ہو گئے',
      entryAllowed: 'داخلہ منظور — لوڈنگ مقام کی طرف بڑھیں',
      entryDenied: 'داخلہ مسترد — براہ کرم انتظار کریں',
      exitRecorded: 'خروج کامیابی سے درج ہوا',
      entryCancelled: 'قطار اندراج منسوخ ہوا',
      queueRefreshed: 'قطار تازہ ہو گئی',
    },

    // Validation
    validation: {
      labelRequired: 'مقام کا نام درکار ہے',
      locationKindRequired: 'مقام کی قسم درکار ہے',
      locationNumberRequired: 'مقام نمبر درکار ہے',
      locationNumberInvalid: 'مقام نمبر مثبت ہونا چاہیے',
      deviceIdRequired: 'ڈیوائس ID درکار ہے',
      deviceIdUnique: 'ڈیوائس ID منفرد ہونی چاہیے',
      variantRequired: 'مصنوعہ درکار ہے',
      maxVehiclesRequired: 'زیادہ سے زیادہ گاڑیاں درکار ہیں',
      maxVehiclesInvalid: 'زیادہ سے زیادہ گاڑیاں کم از کم 1 ہونی چاہیے',
      orderRequired: 'آرڈر درکار ہے',
      duplicateEntry: 'آرڈر کے لیے قطار اندراج پہلے سے موجود ہے',
      invalidToken: 'داخلہ ٹوکن غلط ہے',
      notReady: 'داخلے کے لیے تیار نہیں — براہ کرم انتظار کریں',
      alreadyEntered: 'فیکٹری میں پہلے سے داخل ہے',
      notInFactory: 'گاڑی فیکٹری میں نہیں',
    },

    // Confirmation
    confirm: {
      deleteLocation: 'کیا آپ واقعی اس لوڈنگ مقام کو حذف کرنا چاہتے ہیں؟',
      deleteLocationWarning:
        'اس سے مقام قطار کے نظام سے ہٹا دیا جائے گا۔ فعال قطار اندراجات متاثر ہوں گے۔',
      deleteRule: 'کیا آپ واقعی اس قاعدہ کو حذف کرنا چاہتے ہیں؟',
      deleteRuleWarning: 'اس سے قاعدہ ہٹا دیا جائے گا اور مقام فال بیک کے ذریعے تفویض ہو سکتا ہے۔',
      cancelEntry: 'کیا آپ واقعی اس قطار اندراج کو منسوخ کرنا چاہتے ہیں؟',
      cancelEntryWarning: 'ڈرائیور کو دوبارہ قطار میں شامل ہونا پڑے گا۔',
    },

    // Empty States
    empty: {
      noLocations: 'کوئی لوڈنگ مقام نہیں ملا',
      noLocationsDescription: 'قطار کا انتظام شروع کرنے کے لیے لوڈنگ مقام بنائیں',
      noRules: 'کوئی قواعد نہیں ملے',
      noRulesDescription: 'لوڈنگ مقام کے لیے قواعد ترتیب دینے کے لیے قاعدہ شامل کریں',
      noEntries: 'کوئی قطار اندراج نہیں ملا',
      noEntriesDescription: 'ڈرائیوروں کے شامل ہونے پر قطار اندراجات ظاہر ہوں گے',
      noEvents: 'کوئی حالیہ واقعات نہیں',
      noEventsDescription: 'قطار کی سرگرمی یہاں ظاہر ہوگی',
    },

    // Instructions
    instructions: {
      showQrAtGate: 'داخلی گیٹ پر یہ QR کوڈ دکھائیں',
      waitForNotification: 'داخلے کے لیے تیار ہونے پر اطلاع کا انتظار کریں',
      proceedToLocation: 'مقررہ لوڈنگ مقام کی طرف بڑھیں',
      followStaffDirections: 'پلانٹ میں عملے کی ہدایات پر عمل کریں',
    },

    // Tooltips
    tooltips: {
      refreshQueue: 'قطار کی پوزیشنوں کا دوبارہ جائزہ لیں اور ڈرائیوروں کو مطلع کریں',
      activeStatus: 'مقام کی دستیابی ٹوگل کریں',
      maxVehicles: 'اس مقام پر بیک وقت ہو سکنے والی گاڑیوں کی زیادہ سے زیادہ تعداد',
      queuePosition: 'قطار میں موجودہ پوزیشن',
    },

    // Error Keys (returned from backend as i18n keys)
    errors: {
      orderNotFound: 'آرڈر نہیں ملا',
      noResourceAssigned: 'شپمنٹ کے لیے کوئی وسیلہ تفویض نہیں',
      alreadyInQueue: 'اس آرڈر کے لیے پہلے سے قطار میں ہے',
      cityRequired: 'براہ کرم قطار میں شامل ہونے سے پہلے شہر منتخب کریں',
      vehiclePlateAlreadyInQueue: 'اس گاڑی کی پلیٹ کا پہلے سے ایک فعال قطار اندراج موجود ہے۔ براہ کرم پچھلا اندراج مکمل یا منسوخ ہونے تک انتظار کریں۔',
      noLoadingLocation: 'کوئی لوڈنگ مقام دستیاب نہیں',
      sapSalesOrderFailed: 'SAP سیلز آرڈر بنانے میں ناکامی۔ دوبارہ کوشش کریں یا سپورٹ سے رابطہ کریں۔',
      insufficientContractBalance: 'کنٹریکٹ بیلنس ناکافی ہے۔ براہ کرم اپنے اکاؤنٹ مینیجر سے رابطہ کریں۔',
      accountRequestInProgress: 'اس اکاؤنٹ کی ایک اور درخواست پر کارروائی جاری ہے۔ براہ کرم تھوڑی دیر بعد دوبارہ اسکین کریں۔',
      noActiveContract: 'کوئی فعال کنٹریکٹ نہیں ملا۔ براہ کرم اپنے اکاؤنٹ مینیجر سے رابطہ کریں۔',
      noSapMaterialCode: 'پروڈکٹ کنفیگریشن کی خرابی۔ براہ کرم اپنے اکاؤنٹ مینیجر سے رابطہ کریں۔',
      entryNotFound: 'قطار اندراج نہیں ملا',
      cannotCancelTerminal: 'مکمل یا میعاد ختم شدہ اندراج منسوخ نہیں کیا جا سکتا',
      locationNotFound: 'لوڈنگ مقام نہیں ملا',
      noActiveQueueEntry: 'رسائی سے انکار — اس گاڑی کے لیے کوئی فعال قطار اندراج نہیں ملا',
      ticketUsedOrCancelled: 'ٹکٹ پہلے ہی استعمال یا منسوخ ہو چکا ہے',
      ticketExpired: 'ٹکٹ کی میعاد ختم ہو گئی',
      alreadyInside: 'رسائی سے انکار — گاڑی پہلے سے سہولت کے اندر ہے',
      notReady: 'جگہ ابھی دستیاب نہیں — اپنی اطلاع کا انتظار کریں',
      scanFailed: 'اسکین ناکام — دوبارہ کوشش کریں',
      fetchLocationsFailed: 'لوڈنگ مقامات لانے میں ناکامی',
      fetchRulesFailed: 'قواعد لانے میں ناکامی',
      createRuleFailed: 'قاعدہ بنانے میں ناکامی',
      updateRuleFailed: 'قاعدہ اپ ڈیٹ کرنے میں ناکامی',
      deleteRuleFailed: 'قاعدہ حذف کرنے میں ناکامی',
      fetchLocationFailed: 'لوڈنگ مقام لانے میں ناکامی',
      createLocationFailed: 'لوڈنگ مقام بنانے میں ناکامی',
      updateLocationFailed: 'لوڈنگ مقام اپ ڈیٹ کرنے میں ناکامی',
      deleteLocationFailed: 'لوڈنگ مقام حذف کرنے میں ناکامی',
      fetchEntriesFailed: 'قطار اندراجات لانے میں ناکامی',
      fetchEntryFailed: 'قطار اندراج لانے میں ناکامی',
      joinFailed: 'قطار میں شامل ہونے میں ناکامی',
      cancelFailed: 'اندراج منسوخ کرنے میں ناکامی',
      fetchDashboardFailed: 'ڈیش بورڈ لانے میں ناکامی',
      fetchEventsFailed: 'واقعات لانے میں ناکامی',
      refreshFailed: 'قطار تازہ کرنے میں ناکامی',
    },

    // Success Keys
    success: {
      welcomeProceed: 'خوش آمدید! اپنی مقررہ بے کی طرف بڑھیں۔',
    },

    // Timeline / Audit Log
    timelineTab: 'ٹائم لائن',
    timelineEmpty: 'ابھی تک کوئی سرگرمی نہیں',
    timelineEmptyDesc: 'اس لوڈنگ مقام میں تبدیلیاں یہاں ظاہر ہوں گی۔',
    historyTab: 'تاریخ',
    historyEmpty: 'کوئی واقعہ درج نہیں',
    historyEmptyDesc: 'اس اندراج کی قطار سرگرمی یہاں ظاہر ہوگی۔',
  },

  common: {
    save: 'محفوظ کریں',
    cancel: 'منسوخ',
    delete: 'حذف',
    edit: 'ترمیم',
    close: 'بند کریں',
    search: 'تلاش',
    filter: 'فلٹر',
    refresh: 'تازہ کریں',
    loading: 'لوڈ ہو رہا ہے...',
    noResults: 'کوئی نتیجہ نہیں ملا',
    actions: 'اقدامات',
    status: 'حیثیت',
    all: 'سب',
    active: 'فعال',
    inactive: 'غیر فعال',
    yes: 'ہاں',
    no: 'نہیں',
    confirm: 'تصدیق کریں',
    back: 'واپس',
    next: 'اگلا',
    print: 'پرنٹ',
    download: 'ڈاؤن لوڈ',
    minutes: 'منٹ',
    hours: 'گھنٹے',
    ago: 'پہلے',
  },
}
